"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BannerZoneMapModule = /** @class */ (function () {
    function BannerZoneMapModule() {
    }
    return BannerZoneMapModule;
}());
exports.BannerZoneMapModule = BannerZoneMapModule;
